import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject, timer, of } from 'rxjs';
import { catchError, map, switchMap, take, takeUntil } from 'rxjs/operators';
import { realTimeService } from 'src/app/services/services/realtime.service';

@Component({
    selector: 'app-clock',
    template: `<span class="clock">{{ time$ | async }}</span>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ClockComponent implements OnInit, OnDestroy {
  time$!: Observable<string>;
  private destroy$ = new Subject<void>();

  constructor(private realTimeService: realTimeService) {}

  ngOnInit(): void {
    this.time$ = this.realTimeService.GetServerTimeWithOffset().pipe(
      take(1),
      // serverTimeStr like "16:31:50" → base Date (today at that time)
      map((serverTimeStr: string) => {
        const [h, m, s] = (serverTimeStr ?? '').split(':').map(n => parseInt(n, 10));
        if ([h, m, s].some(n => Number.isNaN(n))) throw new Error('Bad time string');
        const base = new Date();
        base.setHours(h, m, s, 0);
        return base.getTime();
      }),
      // if API fails, start from local now
      catchError(() => of(Date.now())),
      // tick every second from base
      switchMap(baseMs =>
        timer(0, 1000).pipe(
          takeUntil(this.destroy$),
          map(i => this.format(new Date(baseMs + i * 1000)))
        )
      )
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private format(date: Date): string {
    const pad = (n: number) => (n < 10 ? '0' + n : '' + n);
    return `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  }
}
